import { encounterInfo } from "dto/encounter.dto";
import { encounter } from "dto/encounter.dto";
import dxInterceptionApi from "services/dxInterception.api";
import { PrefillDto } from "dto/prefill.dto";

const encounterService = {
    getEncounter: async (transactionNumber: string) => {
        return dxInterceptionApi.get(`/encounters/${transactionNumber}`);
    },
    getPrefill: async (hospitalNumber: string) => {
        return dxInterceptionApi.get<PrefillDto[]>(`/encounters/prefill`, {
            params: {
                hospitalNumber
            }
        });
    },
    createEncounter: async (payload: encounterInfo) => {
        return dxInterceptionApi.post("/encounters", payload);
    },
    updateEncounter: async (id: string, payload: encounterInfo) => {
        return dxInterceptionApi.put(`/encounters/${id}`, payload);
    },
    getEncounterByHNAndTXNAndService: async (
        hospitalNumber: string,
        transactionNumber: string,
        service?: string
    ) => {
        return dxInterceptionApi.get<encounter>("/encounters", {
            params: {
                hn: hospitalNumber,
                txn: transactionNumber,
                service
            }
        });
    },

    saveBinaryMRIS: async (
        hospitalNumber: string,
        transactionNumber: string,
        service?: string
    ) => {
        return dxInterceptionApi.get<encounter>(
            "/encounters/save/binary-mris",
            {
                params: {
                    hn: hospitalNumber,
                    txn: transactionNumber,
                    service
                }
            }
        );
    }
};

export default encounterService;
